import { render, staticRenderFns } from "./TotalizadorNota.vue?vue&type=template&id=1403b746&"
import script from "./TotalizadorNota.vue?vue&type=script&lang=js&"
export * from "./TotalizadorNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports